module.exports = __webpack_public_path__ + "image/leaf_img5.png";